var map = {
	"./bruk-mar-logo.webp": 7972,
	"./cts-logo.webp": 2417,
	"./domelo-logo.webp": 8493,
	"./feda-logo.webp": 8873,
	"./joniec-logo.webp": 9401,
	"./kamal-logo.webp": 5875,
	"./kefal-logo.webp": 9916,
	"./sandbruk-logo.webp": 4049,
	"./superbet-logo.webp": 609,
	"./superbruk-logo.webp": 1684,
	"./vestone-logo.webp": 7419
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6447;